import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import Indicator from '../../Indicator';
import ModalAlert from '../../ModalAlert';
import {CursorTextarea} from '../../Form';
import Api from '../../../api';


export default class AddComplaintPopup extends ModalAlert {

  static defaultProps = {
    action: 'Отправить'
  };

  // lock mouse wheel in textarea
  onWheel(e) {
    const textarea = ReactDOM.findDOMNode(this.refs.textarea);
    if (
      e.target !== textarea
      ||
      textarea.scrollHeight <= textarea.offsetHeight
      ||
      (textarea.scrollTop == 0 && e.deltaY < 0)
      ||
      (textarea.scrollTop + textarea.offsetHeight >= textarea.scrollHeight && e.deltaY > 0)
    ) {
      e.preventDefault();
    }
  }

  async onAction() {
    const {gameData} = this.props;
    if (gameData.hasData('complaintText')) {
      this.setState({
        progress: true
      });
      await Api.gameAddComplaint(gameData.get('id'), gameData.get('complaintText'));
      this.setState({
        success: true
      });
      this.close();
    }
  }

  onCloseAnimationEnd() {
    super.onCloseAnimationEnd();
    if (this.state.success) {
      this.props.gameData.removeIn('complaintText');
    }
  }

  renderMessage() {
    return (
      <div className='AddComplaintPopup'>
        <div className='AddComplaintPopup-Title'>Пожаловаться</div>
        <div className='AddComplaintPopup-Subtitle'>Жалоба будет отправлена судье матча.</div>
        <CursorTextarea value={this.props.gameData.cursor('complaintText')} disabled={this.state.progress}
                        ref='textarea' className='AddComplaintPopup-Textarea' />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/GameDetails/AddComplaintPopup.js